import React from 'react';
import { getLength } from '@collaborator/npm_modules/dist/helpers/string/StringHelper';

var Counter = function Counter(_ref) {
  var _ref$isAvailable = _ref.isAvailable,
      isAvailable = _ref$isAvailable === void 0 ? true : _ref$isAvailable,
      value = _ref.value;

  if (!isAvailable) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "text-counter text-success"
  }, getLength(value));
};

export { Counter };